import React, { useState, useEffect } from "react";
import CourseCard from "../Card-Component/CourseCard";
import { useDispatch, useSelector } from "react-redux";
import { setAllCoursesCache } from "../../configs/cache";
import { PAGE_LIMIT } from "../../constants/text_constants";
import LoadingLottie from "../Lottie-Components/LoadingLottie";
import { UNPROTECTED_ROUTES } from "../../routes/routes";
import { useNavigate } from "react-router-dom";
import userLogout from "../../utils/userLogout";
import { useLocation } from "react-router-dom";
import IntegratedPagination from "../Pagination/IntegratedPagination";

const AllCoursesList = () => {
  const location = useLocation();
  const [allCoursesData, setAllCoursesData] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const cache = useSelector((store) => store.cache.allCoursesCache);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const fetchAllCourses = async (retries = 6) => {
    try {
      const userAuthenticated = sessionStorage.getItem("authenticated") === "1";
      const authToken =
        sessionStorage.getItem("token") || process.env.REACT_APP_TEMP_TOKEN;
      const response = await fetch(
        process.env.REACT_APP_RANK_PLUS_ALL_COURSES_DATA + currentPage,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (!response.ok) {
        if (
          userAuthenticated &&
          response.status >= 400 &&
          response.status < 500
        ) {
          userLogout(navigate, dispatch, true);
        }
        if (response.status >= 500 && response.status < 600 && retries > 0) {
          console.warn(`Retrying... attempts left: ${retries}`);
          setTimeout(() => fetchAllCourses(retries - 1), 10000);
          return;
        } else {
          throw new Error(`HTTP error: ${response.status}`);
        }
      }
      const json = await response.json();
      setAllCoursesData(json?.data);
      setTotalPages(Math.ceil((json?.data?.total || 0) / PAGE_LIMIT));
      dispatch(setAllCoursesCache([json?.data, currentPage]));
    } catch (err) {
      console.error("Error fetchAllCourses", err);
    }
  };

  // Reset state when the route (tab) changes
  useEffect(() => {
    setAllCoursesData(null);
    setCurrentPage(0);
    setTotalPages(0);
  }, [location.pathname]);

  useEffect(() => {
    if (cache[currentPage]) {
      setAllCoursesData(cache[currentPage]);
      setTotalPages(Math.ceil((cache[currentPage]?.total || 0) / PAGE_LIMIT));
    } else {
      fetchAllCourses();
    }
    // eslint-disable-next-line
  }, [currentPage, location.pathname]);

  if (!allCoursesData || allCoursesData?.courses.length === 0) {
    return <LoadingLottie />;
  }
  console.log("111111111111111",allCoursesData);
  console.log("22222222222222",currentPage);
  console.log("33333333333333",totalPages);
  return (
    <>
    <div className=" grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 lg:gap-8 gap-4">
      {allCoursesData?.courses.map((ele, i) => (
        <CourseCard
          key={i}
          name={ele?.name}
          offer_price={ele?.offer_price}
          offer_discount={ele?.offer_discount}
          price={ele?.price}
          payment_plans={ele?.payment_plans || []}
          course_banner={ele?.course_banner}
          title_1={"Duration"}
          value_1={ele?.duration}
          title_2={"Start Date"}
          value_2={ele?.starts_on}
          title_3={"End Date"}
          value_3={ele?.ends_on}
          title_4={"Validity"}
          value_4={ele?.validity}
          rating={ele?.rating}
          faculty_name={ele?.faculty_name}
          thumbnail={ele?.faculty_thumbnail}
          description={ele?.description}
          totalRating={ele?.total_rating}
          id={ele?.id}
          exploreMoreLink={UNPROTECTED_ROUTES?.courseDetails}
          showPrice={true}
          showBuyNow={false}
          showExploreMore={true}
          showView={false}
        />
      ))}    
    </div>
    <div className="mt-[2rem] mb-[7rem]">
        <IntegratedPagination
          currentPage={currentPage + 1}
          totalPages={totalPages}
          setCurrentPage={(page) => setCurrentPage(page - 1)}
        />
    </div>
    </>
  );
};

export default AllCoursesList;
